App.updateShipping = (data) ->
  App.shipping = data.shipping
  App.due_date = data.due_date
  App.order.set 'stock', data.stock
  App.order.set 'shippingService', data.service
  shipping = $('#shipping-service')
  shipping.html ''
  for k in data.shipping
    shipping.append App.tplShipping(k)
  if App.shipping[App.order.get('shippingService')]?
    App.due_date = data.due_date
    App.order.set 'term', App.shipping[App.order.get('shippingService')]
    App.order.set 'due_date', App.due_date[App.order.get('shippingService')]
  return

App.updateTotals =  (data) ->
  if data.shipping_type != 'courier' && data.total_express == 0
    $('.transport-total').hide()
    $('.transport-total-label').hide()
  else
    $('.transport-total').show()
    $('.transport-total-label').show()
    $('.transport-total').html if data.total_transport > 0 \
      then formatPrice(data.total_transport) else 'GRATUIT'
  if data.stock
    $('.transport-total-label').html 'Livrare din stoc'
  else
    if data.service == 'exp'
      $('.transport-total-label').html 'Livrare express'
    else
      $('.transport-total-label').html 'Livrare economică'
  if data.total_discount > 0
    $('.order-discount-label').removeClass 'hidden'
    $('.order-discount').removeClass 'hidden'
    $('.order-discount').html '-' + formatPrice(data.total_discount)
  else
    $('.order-discount-label').addClass 'hidden'
    $('.order-discount').addClass 'hidden'
  $('.products-total').html formatPrice(data.total_products)
  $('.order-total').html \
    formatPrice(data.total_products - data.total_discount + data.total_transport)

App.updateCartUser = (name, value, callback) ->
  url = '/update-cart-details'
  if value || value == false
    data = {}
    data[name] = value
    $.post(url, data, callback)
  else
    $.getJSON(url + '/' + name, {}, callback)
  return

App.initHandlers = ->
  $('#shipping-service').on 'click', '.radio-box', ->
    radio = $(this).find('input[type="radio"]')
    radio.prop 'checked', true
    $('.radio-box').removeClass 'radio-selected'
    $(this).addClass 'radio-selected'
    App.order.set 'shippingService', radio.val()
    App.order.set 'term', App.shipping[radio.val()]
    App.order.set 'due_date', App.due_date[radio.val()]
    App.updateCartUser('shipping_service', \
    (if radio.val() == 'eco' then '1' else '0'), (data) -> App.cart.updateTotal(data))
    return

$ ->
  _.templateSettings.variable = '$rc'

  $.extend App, {
    newOrder: {
      company: {}
      address: {}
      current_company: null
      current_address: null
      courier: 'fan'
      shipping: 'courier'
      invoice: 'person'
      payment: 'card'
      weekend: false
      discountVoucher: 0
      discountPoints: 0
      voucher: ''
      points: 0
      stock: false
      shippingService: 'eco'
      note: ''
      newsletter_subscribe: false
      refreshCart: false
    }
  }

  App.initItems()
  App.initSave4Later()

  App.Model.Order = Backbone.Model.extend()

  App.order = new (App.Model.Order)(App.newOrder)
  App.tplShipping = _.template($('#shipping-template').html())
  App.initHandlers()
  App.order.set 'shipping', data.user.details.shipping
  App.order.set 'discount', data.discount
  App.order.set 'shippingService', data.service
  App.updateCartUser('shipping_service', \
  (if data.service == 'eco' then '1' else '0'), (data) -> App.cart.updateTotal(data))
  App.order.set 'stock', data.stock
  App.order.set 'courierCost', data.courier_cost

  App.cartItems = new (App.Collection.Items)
  for k of data.items
    if data.items.hasOwnProperty(k)
      App.cartItems.add new (App.Model.Item)(data.items[k])
  App.cart = new App.View.ShoppingCart

  gaData = {
    currency: 'RON'
    value: data.total_products - data.total_discount
    items: []
  }
  App.cartItems.each ((item) ->
    gaData.items.push {
      item_id: item.get('ean')
      item_name: item.get('title')
      discount: item.get('discount')
      price: item.get('price') + \
        (if App.order.get 'shippingService' == 'exp' then item.get 'express' else 0)
      quantity: item.get('quantity')
    }
  )
  gtag('event', 'view_cart', gaData)

  if data.items.length > 0
    if data.save4later.length > 0
      App.save4laterItems = new (App.Collection.LaterItemsCollection)
      for k of data.save4later
        if data.save4later.hasOwnProperty(k)
          App.save4laterItems.add new (App.Model.LaterItem)(data.save4later[k])
      App.viewSave4Later = new (App.View.LaterItems)
      $('#later-items-text').removeClass 'hidden'
      $('#later-items').removeClass 'hidden'
  else
    $('.cart-empty').removeClass 'hidden'
    if data.save4later.length > 0
      App.save4laterItems = new (App.Collection.LaterItemsCollection)
      for k of data.save4later
        if data.save4later.hasOwnProperty(k)
          App.save4laterItems.add new (App.Model.LaterItem)(data.save4later[k])
      App.viewSave4Later = new (App.View.LaterItems)
      $('#later-items-text').removeClass 'hidden'
      $('#later-items').removeClass 'hidden'
    else
      $('aside').detach()

  $('body').on 'click', '#add-products-to-cart', ->
    $.post '/merge-carts', {
      email: App.order.get('email')
    }, (data) ->
      if data.success
        App.cartItems.each ((item) ->
          App.cartItems.remove(App.cartItems.where({ ean: item['ean'] }))
        )
        for item in data.items
          App.cartItems.add new (App.Model.Item)(item)
        App.cart.render()
        App.order.set 'refreshCart', true
        $('#add-products-to-cart').closest('.box').trigger('close')
      else
        $('#add-products-to-cart').closest('.box').trigger('close')
      return
    return
  $('body').on 'click', '#add-products-to-save4later', ->
    $.post '/add-products-to-save4later', {
      email: App.order.get('email')
    }, (data) ->
      if data.success
        if !App.save4laterItems
          App.save4laterItems = new (App.Collection.LaterItemsCollection)
          App.viewSave4Later = new (App.View.LaterItems)
        for item in data.items
          App.save4laterItems.add new (App.Model.LaterItem)(item)
        App.viewSave4Later.render()
        if App.save4laterItems.size() > 0
          $('#later-items-text').removeClass 'hidden'
          $('#later-items').removeClass 'hidden'
        App.order.set 'refreshCart', true
        $('#add-products-to-save4later').closest('.box').trigger('close')
      else
        $('#add-products-to-save4later').closest('.box').trigger('close')
      return
    return
  return
